import { Component, computed, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { ConfirmationDialogComponent } from "../../layout/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from '@angular/material/dialog';
import { CommonUtils } from '../../utils/common.utils';
import { ERROR_RESPONSE } from '../../model/api.model';
import {  LucideDynamicIcon, LucideHardDriveDownload } from '@lucide/angular';


@Component({
  selector: 'app-download-button',
  standalone: true,
  imports: [LucideDynamicIcon],
  templateUrl: './download-button.component.html',
  styleUrl: './download-button.component.scss'
})
export class DownloadButtonComponent implements OnChanges {
  @Input() exportMessage = 'data';
  @Input() tableValues: any;
  @Input() DownloadClicked!: any;
  @Output() buttonClicked = new EventEmitter<any>();
  protected readonly model = signal<boolean>(true);
  protected readonly icon = computed(() => LucideHardDriveDownload);

  constructor(private readonly dialog: MatDialog, private readonly commonUtils: CommonUtils) {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["exportMessage"]) {
      this.exportMessage = changes["exportMessage"].currentValue;
    }
  }

  openDialog() {
    const data: Array<any> = structuredClone(this.tableValues) ?? [];
    if (data.length <= 0) {
      this.commonUtils.showMatSnackBar(ERROR_RESPONSE.noDataToDownload)
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: { message: `Do you want to download the ${this.exportMessage} ?`, header: "Download File" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buttonClicked.emit();
      }
    });
  }
  onDownloadClick() {
    this.buttonClicked.emit();
  }
}
